import { Dtos, SuretyAccountId, SuretyBondId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { accountQueryKey } from "../../account/account.keys";
import { bondPreviewsQueryKey, bondQueryKey } from "../bond.keys";

export const useAdminCloseBond = (suretyBondId: SuretyBondId, accountId: SuretyAccountId) => {
	const queryClient = useQueryClient();
	const { post } = useRequest();

	const mutation = useMutation({
		mutationFn: async (data: Dtos.Admin.SuretyBond.Close.Request): Promise<void> => {
			await post(`/v2/admin/surety/bonds/${suretyBondId}/close`, data, "none");
		},
		onSuccess: () => {
			queryClient.refetchQueries({ queryKey: bondQueryKey(suretyBondId) });
			queryClient.refetchQueries({ queryKey: bondPreviewsQueryKey() });
			queryClient.invalidateQueries({ queryKey: accountQueryKey(accountId) });
		},
	});

	return { closeBond: mutation.mutate, closeBondLoading: mutation.isPending };
};
